// De-duplicates rows coming back from the assignment based resource
// allocation endpoints. Those endpoints return one row per allocation, so
// the same person or project can be repeated several times and would then
// show up as duplicate values in the dropdowns.
//
// The first occurrence of a key wins and any empty/null field on it is filled
// in from the later duplicates (for example a non null internalUserId).
export const uniqueBy = (list, getKey) => {
  const result = [];
  const indexByKey = new Map();

  (Array.isArray(list) ? list : []).forEach((item) => {
    const key = getKey(item);

    if (key === undefined || key === null || key === '') {
      result.push(item);
      return;
    }

    if (!indexByKey.has(key)) {
      indexByKey.set(key, result.length);
      result.push(item);
      return;
    }

    const existingIndex = indexByKey.get(key);
    const merged = { ...result[existingIndex] };

    Object.keys(item).forEach((field) => {
      const isEmpty =
        merged[field] === undefined || merged[field] === null || merged[field] === '';

      if (isEmpty && item[field] !== undefined && item[field] !== null && item[field] !== '') {
        merged[field] = item[field];
      }
    });

    result[existingIndex] = merged;
  });

  return result;
};